"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _svg4everybody = _interopRequireDefault(require("svg4everybody"));

var _flags = _interopRequireDefault(require("../assets/flags.svg"));

var _sizes = _interopRequireDefault(require("./utils/sizes"));

require("../css/flag.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

if (typeof window !== 'undefined') {
  (0, _svg4everybody.default)({
    polyfill: true
  });
}

var Flag = function Flag(_ref) {
  var _classnames;

  var className = _ref.className,
      name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = _objectWithoutProperties(_ref, ["className", "name", "size"]);

  var classes = (0, _classnames2.default)((_classnames = {
    'vn-flag': true
  }, _defineProperty(_classnames, "vn-flag--size-".concat(size), true), _defineProperty(_classnames, className, className), _classnames));
  return _react.default.createElement("svg", _extends({
    className: classes,
    focusable: false,
    key: name,
    version: "1.1",
    viewBox: "0 0 640 480"
  }, props), _react.default.createElement("use", {
    xlinkHref: "".concat(_flags.default, "#").concat(name)
  }));
};

Flag.propTypes = {
  className: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  size: _propTypes.default.oneOf(_sizes.default)
};
Flag.defaultProps = {
  className: undefined,
  size: 24
};
Flag.displayName = 'Flag';
var _default = Flag;
exports.default = _default;